export default __webpack_public_path__ + "static/media/grey3-bottom.38573b49.svg";